import React, { Component, createRef } from 'react';
import { Spin, Divider, Tabs } from 'antd';
import ResultLayout from '../../../../services/Result/Public/resultLayout';
import WaveformSetting from '../../../../services/Result/Public/waveform/waveformSetting';
import { getVerificationJson } from '../../../../services/Andes_v2/results'
import BathtubPlot from '../../../../services/Andes_v2/results/simulation/BathtubPlot';
import ResultRightMenu from '../../../../services/Result/Public/resultRightMenu';
import ResultList, { RESULT } from '../../../../components/Sparameter/resultList';
import { rowDisplayChange } from '../../../../services/Result/Public/sparameter/resultsMenuHelper';
import { selectedChange, cancelMove } from '../../../../services/Result/Public/sparameter/dataHelper';
import getIndex from '../../../../services/helper/insertionSearch';
import { changeCurveColor } from '../../../../services/Result/Public/sparameter/dataHelper';
import { checkResultStatus, GET, CLEAN } from '../../../../services/helper/resultStatus';
import { getChannelBathtubRawFilePromise, getEndToEndBathtubRawFilePromise } from '../../../../services/Andes_v2/results/resultCtrl';
import { getBathtubCurveData, getBathtubResultList } from '../../../../services/Andes_v2/results/waveform';
import BathtubWidthTable from "./BathtubWidthTable"

const BATHTUB_TIME = "BATHTUB_TIME", BATHTUB_VOLTAGE = "BATHTUB_VOLTAGE";
class BathtubCurve extends Component {

  constructor() {
    super()
    this.svgRef = createRef();
    this.state = {
      loading: true,
      resultsObj: {}, //  { time: { list: [{ rowName: "", children: [{ id, name, color, value }] }], show: ["rowName"] }, voltage: {}}
      portSelect: {},
      displayMode: BATHTUB_VOLTAGE // BATHTUB_TIME | BATHTUB_VOLTAGE
    }
    this.isPreLayout = false;
    // Solve Aynchronous causes memory leakage and updates after component removal
    this.isUpdate = false;
  }

  onRef = (ref) => {
    this.waveformSetting = ref;
  }

  componentDidMount() {
    this.isUpdate = true;
    if (this.props.id) {
      this.getBathtub();
    }
  }

  componentDidUpdate(prevProps) {
    const { id, resultKey, status } = this.props;
    if (id !== prevProps.id || resultKey !== prevProps.resultKey) {
      this.getBathtub();
    }

    // status
    if (id === prevProps.id && prevProps.status !== status) {
      const updateStatus = checkResultStatus(prevProps.status, status);
      switch (updateStatus) {
        case GET:
          // reload result data
          this.getBathtub();
          break;
        case CLEAN:
          this.initResult();
          break;
        default: break;
      }
    }
  }

  componentWillUnmount() {
    this.initResult();
    this.isUpdate = false;
  }

  getList = () => {
    const { resultsObj, displayMode } = this.state;
    return resultsObj[displayMode] ? (resultsObj[displayMode].list || []) : [];
  }

  changeMouse = (time, yPrefix) => {
    const curves = BathtubPlot.getCurves();
    let { resultsObj, displayMode } = this.state;
    if (!curves || !curves.length) return;
    for (const curve of curves) {
      const { listIndex, childIndex } = this.getListChildIndex(curve, this.getList());
      if (listIndex < 0) return;
      if (curve.visible && curve.y && curve.y.length) {
        const index = this._getIndex(curve.x, time);
        const value = index > -1 ? yPrefix(curve.y[index]) : '';
        resultsObj[displayMode].list[listIndex].children[childIndex].value = value;
      } else {
        resultsObj[displayMode].list[listIndex].children[childIndex].value = '';
      }
    };
    this.setState({
      resultsObj
    })
  }

  getListChildIndex(curve, list) {
    for (let i = 0; i < list.length; i++) {
      for (let j = 0; j < list[i].children.length; j++) {
        if (list[i].children[j].id === curve.name && list[i].children[j].rowName === curve.rowName) {
          return {
            listIndex: i,
            childIndex: j
          }
        }
      }
    }
    return {
      listIndex: -1,
      childIndex: -1
    }
  }

  _getIndex(xPoints, time) {
    return getIndex(xPoints, time, 0, xPoints.length - 1);
  }

  getCurrentSelects = () => {
    let { portSelect, displayMode } = this.state;
    if (!portSelect || !portSelect[displayMode]) {
      return [];
    }
    return Object.values(portSelect[displayMode]).reduce((a, b) => {
      return Object.values(a).concat(...Object.values(b));
    }, []);
  }

  cancelMove = () => {
    const { resultsObj, displayMode } = this.state;
    const selectArr = this.getCurrentSelects();
    this.setState({
      resultsObj: cancelMove({ resultsObj, displayMode, selectArr }),
    })
  }

  changeAxis = (axis) => {
    this.waveformSetting.setAxis(axis);
  }

  initResult = () => {
    this.setState({
      resultsObj: {},
      portSelect: {},
      displayMode: BATHTUB_VOLTAGE,
      loading: true
    })
    BathtubPlot.cleanBathtubPlot();
    if (this.plot2D) {
      if (this.svgRef && this.svgRef.current && this.svgRef.current.children && this.svgRef.current.children[0]) {
        this.svgRef.current.removeChild(this.svgRef.current.children[0]);
      }
    }
    this.plot2D = null;
  }

  getCurves = (displayMode, rowName) => {
    const curves = BathtubPlot.getCurvesList(displayMode);

    if (rowName) {
      return curves.filter(curve => curve.rowName === rowName);
    }

    return curves;
  }

  getBathtub = async (ifInitResult = true) => {
    this.interfaceContent = null;
    if (ifInitResult) {
      this.initResult();
    }
    const { displayMode } = this.state;
    const { id, isEndToEnd, setupInfo } = this.props;
    this.interfaceContent = setupInfo || await getVerificationJson(id, isEndToEnd);
    if (!this.interfaceContent || !this.isUpdate) return;

    const resultsObj = {}, bathtubObj = { [BATHTUB_TIME]: {}, [BATHTUB_VOLTAGE]: {} };
    const signals = isEndToEnd ? this.interfaceContent.signals : this.interfaceContent.content.signals;
    for (const signal of signals) {
      const rawFiles = isEndToEnd ? await getEndToEndBathtubRawFilePromise({ endToEndChannelId: id, signalName: signal.name }) : await getChannelBathtubRawFilePromise({ channelId: id, signalName: signal.name });
      for (const rawFileName of rawFiles) {
        const bathtub = await getBathtubCurveData({ id, rawFileName, signalName: signal.name, isEndToEnd });
        const type = /timingbathtub/i.test(rawFileName) ? BATHTUB_TIME : BATHTUB_VOLTAGE;
        if (Object.keys(bathtubObj[type]).length > 0) {
          bathtubObj[type].curveData.push(...bathtub.curveData);
          bathtubObj[type].signals.push(...bathtub.signals);
          bathtubObj[type].times.push(bathtub.time);
        } else {
          bathtubObj[type] = { ...bathtub, times: [bathtub.time] };
        }
      }
    }

    for (const type of [BATHTUB_VOLTAGE, BATHTUB_TIME]) {
      const res = await this.bathtubDataProcess({ bathtub: bathtubObj[type], id, type });
      resultsObj[type] = { list: res.list, show: res.show };
    }

    const curves = BathtubPlot.getCurvesList(displayMode);
    BathtubPlot.setCurves(curves);

    let portSelect = { ...this.state.portSelect };
    if (portSelect[displayMode] && portSelect[displayMode][id]) {
      portSelect[displayMode][id] = {};
    }

    if (id === this.props.id && this.isUpdate) {
      this.setState({
        resultsObj,
        portSelect
      }, () => {
        displayMode === BATHTUB_VOLTAGE && this.bathtubWidthTable.initData(portSelect[displayMode] && portSelect[displayMode][id] ? portSelect[displayMode][id] : {});
      })
      this.initSelect(resultsObj[displayMode], id);
    }
  }

  bathtubDataProcess = async ({ bathtub, id, type }) => {
    if (!this.isUpdate) return;
    let axis = null;
    if (type === BATHTUB_TIME) {
      axis = { yUnit: 'BER', yLabel: 'log', xUnit: 's', xLabel: 'Time', ui: 1e-9 };
    } else if (type === BATHTUB_VOLTAGE) {
      axis = { yUnit: 'BER', yLabel: 'log', xUnit: 'V', xLabel: 'Voltage', ui: 1 };
    } else {
      return;
    }
    const events = {
      changeMouse: this.changeMouse,
      cancelMove: this.cancelMove,
      changeAxis: this.changeAxis,
    };
    this.plot2D = BathtubPlot.plotBathtub({ svgElement: this.svgRef.current, events, bathtub, axis, id, type, ui: type === BATHTUB_TIME ? 1e-9 : 1 });
    const curves = BathtubPlot.getCurvesList(type).filter(d => d.id === id);
    return this.getResultList({ curves })
  }

  initSelect = (resultObj, id) => {
    if (resultObj.list.length > 0) {
      const values = resultObj.list[0].children.map(d => d.id)
      this.changePort(values, resultObj.list[0].rowName, id, []);
    }

    this.setState({ loading: false });
  }

  updateCureves = (values, key, id, prevSelects) => {
    let _prevSelects = prevSelects;
    const { portSelect, displayMode } = this.state;
    try {
      const curves = this.getCurves(displayMode, key);
      // set state
      if (!_prevSelects) {
        _prevSelects = (portSelect[displayMode] && portSelect[displayMode][id] && portSelect[displayMode][id][key]) || [];
      }
      const { unchecks, newChecks } = selectedChange({ prevSelects: _prevSelects, values })
      unchecks.forEach(un => {
        const curveIndex = curves.findIndex(d => d.name === un);
        if (curveIndex > -1) {
          curves[curveIndex].visible = false;
        }
      })
      newChecks.forEach(ne => {
        const curveIndex = curves.findIndex(d => d.name === ne);
        curves[curveIndex].visible = true;
      })
      this.updatePortSelect(key, values, id)
    } catch (error) {
      console.error(error);
    }
  }
  // values: []
  changePort = (values, key, id, prevSelects) => {
    this.updateCureves(values, key, id, prevSelects);
    this.plot2D.updatePlot();
  }

  updatePortSelect = (rowName, values, id) => {
    const { displayMode } = this.state;
    this.setState((prevState) => {
      let _portSelect = prevState.portSelect;
      if (!_portSelect[displayMode]) {
        _portSelect[displayMode] = {};
      }
      if (!_portSelect[displayMode][id]) {
        _portSelect[displayMode][id] = {};
      }
      _portSelect[displayMode][id][rowName] = values;

      displayMode === BATHTUB_VOLTAGE && this.bathtubWidthTable.drawWidthLine(null, _portSelect[displayMode] && _portSelect[displayMode][id] ? _portSelect[displayMode][id] : {});
      return {
        portSelect: _portSelect
      }
    });
  }

  getResultList = ({ curves }) => {
    const { isEndToEnd } = this.props;
    return getBathtubResultList({ curves, isEndToEnd });
  }

  changeWidthCB = () => {
    if (this.plot2D) {
      this.plot2D.redrawPlot(this.svgRef.current);
    }
  }

  axisChangeCB = (type, { _xMin, _xMax, _yMin, _yMax }) => {
    const plot = this.plot2D;
    const { displayMode } = this.state;
    if (type === 'xMin' || type === 'xMax') {
      let xMax = plot.options.xMax,
        xMin = plot.options.xMin,
        start = parseFloat(_xMin) * (displayMode === BATHTUB_VOLTAGE ? 1 : 1e-9),
        end = parseFloat(_xMax) * (displayMode === BATHTUB_VOLTAGE ? 1 : 1e-9);

      if (parseFloat(start).toString() === 'NaN') {
        start = 0;
      };
      if (parseFloat(end).toString() === 'NaN') {
        end = 0;
      };

      plot.xScale
        .domain([Math.min(start, end), Math.max(start, end)])
        .range([0, plot.size.width]);

      const xrange = plot.xScale.domain(),
        width = plot.size.width,
        startX = (xrange[0] - xMin) / (xMax - xMin) * width,
        endX = (xrange[1] - xMin) / (xMax - xMin) * width;
      plot.updateRange(startX, endX);
    } else {
      // y axis
      let yStart = parseFloat(_yMin),
        yEnd = parseFloat(_yMax);

      if (parseFloat(yStart).toString() === 'NaN') {
        yStart = 0;
      };
      if (parseFloat(yEnd).toString() === 'NaN') {
        yEnd = 0;
      };

      plot.yScale
        .domain([Math.max(yStart, yEnd), Math.min(yStart, yEnd)])
        .nice()
        .range([0, plot.size.height])
        .nice();
    }
    this.reloadAxisCB();
  }

  reloadAxisCB = () => {
    this.plot2D.updatePlot();
  }

  colorChange = (e, key, rowName) => {
    const value = e.toHexString()
    if (value) {
      const { displayMode } = this.state;
      const curves = this.getCurves(displayMode, rowName);
      const curveIndex = curves.findIndex(d => d.name === key);
      curves[curveIndex].color = value;
      this.reloadAxisCB()
      this.setResultObjColor(e, key, rowName);
    }
  }

  setResultObjColor = (e, key, rowName) => {
    const { id } = this.props;
    const { resultsObj, displayMode, portSelect } = this.state;
    //result
    const { resultList } = changeCurveColor({ e, key, resultList: resultsObj, displayMode, rowName })
    this.setState({
      resultsObj: resultList
    }, () => {
      displayMode === BATHTUB_VOLTAGE && this.bathtubWidthTable.initData(portSelect[displayMode] && portSelect[displayMode][id] ? portSelect[displayMode][id] : {});
    })
  }

  rowNameClick = (displayMode, value) => {
    this.setState({
      resultsObj: rowDisplayChange(this.state.resultsObj, displayMode, value)
    })
  };

  changeSelectAll = (e, group, id) => {
    const check = e.target.checked;
    if (check) {
      this.changePort(group.children.map(d => d.id), group.rowName, id)
    } else {
      this.changePort([], group.rowName, id)
    }
  }

  resultLeft = () => {
    const { loading } = this.state;
    return (
      <Spin spinning={loading} size='large'>
        <div
          className='waveform-svg'
          style={{ width: "100%", height: "100%" }}>
          <svg ref={this.svgRef}></svg>
        </div>
      </Spin>
    )
  }

  customizeTitle = (item) => {
    return <span className='andes-customized-title'>{item.displayText}</span>
  }

  setBathtubVoltageWidthLine = (arrowLine) => {
    if (!this.plot2D || !this.plot2D.targetLine) return;

    // save data
    this.plot2D.targetLine.setValue({ arrowLine });
    this.plot2D.targetLine.drawLines(this.plot2D.root, "arrowLine");
  }

  resultListRender = () => {
    const { portSelect, resultsObj, displayMode } = this.state;
    const { id } = this.props;
    return (
      <div>
        {/* Result list */}
        <ResultList
          type={RESULT}
          fileId={id}
          rowId={id}
          displayMode={displayMode}
          portSelect={portSelect[displayMode] && portSelect[displayMode][id] ? portSelect[displayMode][id] : {}}
          changePort={this.changePort}
          colorChange={this.colorChange}
          resultList={resultsObj}
          rowNameClick={this.rowNameClick}
          changeSelectAll={this.changeSelectAll}
          customizeTitle={this.customizeTitle}
        />

        {/* Eye Width*/}
        {displayMode === BATHTUB_VOLTAGE
          ? <BathtubWidthTable
            ref={(ref) => this.bathtubWidthTable = ref}
            resultList={resultsObj[displayMode]}
            portSelect={portSelect[displayMode] && portSelect[displayMode][id] ? portSelect[displayMode][id] : {}}
            xUnit={this.plot2D && this.plot2D.getDispalyXUnit ? this.plot2D.getDispalyXUnit() : "V"}
            setBathtubVoltageWidthLine={this.setBathtubVoltageWidthLine}
          />
          : null}
      </div>
    )
  }

  settingRender = () => {
    const { displayMode } = this.state;
    return (
      <div>
        <Divider
          orientation="left"
          className='waveform-setting-title'
          style={{
            margin: "6px 0px"
          }}
        >Setting</Divider>
        <div className='andes-v2-waveform-setting-css'>
          <WaveformSetting
            onRef={this.onRef}
            plot={this.plot2D}
            axisChangeCB={this.axisChangeCB}
            reloadAxisCB={this.reloadAxisCB}
            currentResultKey={displayMode}
          />
        </div>
      </div>
    )
  }

  resultModeChange = (key) => {
    const { id } = this.props;
    const { resultsObj, portSelect, displayMode } = this.state;
    const prevSelects = [];
    try {
      for (const rowName of Object.keys(portSelect[displayMode][id])) {
        prevSelects.push(...portSelect[displayMode][id][rowName]);
      }
    } catch (error) {
      console.error(error);
    }

    if (key === BATHTUB_TIME) {
      this.setBathtubVoltageWidthLine([]);
    }
    this.setState({ displayMode: key }, () => {
      try {
        const values = resultsObj[key].list[0].children.map(d => d.id);
        //  plot option
        this.plot2D.updateOptions(key === BATHTUB_TIME ? { xUnit: 's', xLabel: 'Time', ui: 1e-9 } : { xUnit: 'V', xLabel: 'Voltage', ui: 1 });
        // plot curves
        const curves = this.getCurves(key);
        BathtubPlot.setCurves(curves);
        // display curve
        this.changePort(values, resultsObj[key].list[0].rowName, id, prevSelects);
        // waveformSetting axis
        this.changeAxis({ xUnit: key === BATHTUB_TIME ? 's' : 'V' });
      } catch (error) {
        console.error(error);
      }
      key === BATHTUB_VOLTAGE && this.bathtubWidthTable.initData(
        portSelect[key] && portSelect[key][id] ? portSelect[key][id] : {},
        this.plot2D && this.plot2D.getDispalyXUnit ? this.plot2D.getDispalyXUnit() : "V"
      );
    })
  }

  rightTopRender = () => {
    const { displayMode } = this.state;
    return <Tabs
      onChange={this.resultModeChange}
      type="card"
      className='andes-result-mode-tab'
      activeKey={displayMode}
      items={[{
        key: BATHTUB_VOLTAGE,
        label: "Voltage Bathtub",
      }, {
        key: BATHTUB_TIME,
        label: "Timing Bathtub",
      }]} />
  }

  resultRight = () => {
    return (
      <ResultRightMenu
        onRef={this.resultRightMenuOnRef}
        resultList={this.resultListRender}
        setting={this.settingRender}
        top={this.rightTopRender}
      />
    )
  }

  render() {
    return (
      <ResultLayout
        resultLeft={this.resultLeft}
        resultRight={this.resultRight}
        changeWidthCB={this.changeWidthCB}
      />
    )
  }
}

export default BathtubCurve